module.exports = __webpack_public_path__ + "img/bg-food-for-mood.2076934.svg";